import 'regenerator-runtime/runtime';

import axios from 'axios';
import { parse } from 'querystringify';

import skeleton from './data/skeleton.json';
import { renderAnimationToCanvas } from './iddleView';
import { initDragonRenderer } from './dragonRenderer';
import { getRacesWeights, parseGenome } from './helper';
import {
  SUBGRAPH_URL,
  SERVER_URL,
  DRAGON_DETAILS_QUERY,
  SIZE_TYPES,
  SERVER_IMAGES_SIZE_MAP,
  DRAGON_SIZE,
} from './constants';

async function render() {
  const transitionDuration = 500; // ms
  const width = DRAGON_SIZE.WIDTH;
  const height = DRAGON_SIZE.HEIGHT;
  const scaleX = Math.min(document.body.clientWidth, DRAGON_SIZE.WIDTH) / DRAGON_SIZE.WIDTH;
  const scaleY = Math.min(document.body.clientHeight, DRAGON_SIZE.HEIGHT) / DRAGON_SIZE.HEIGHT;
  const scale = Math.min(scaleX, scaleY);
  const { id } = parse(location.search);

  if (Number.isNaN(parseInt(id, 10))) {
    throw new Error('Id must be a number');
  }

  const root = document.getElementById('root');
  const img = document.createElement('img');

  root.style.transform = `scale(${scale})`;
  root.style.transformOrigin = 'left top';

  const removeImage = () => {
    root.removeChild(img);
    img.removeEventListener('error', removeImage);
  };

  img.addEventListener('error', removeImage);
  img.setAttribute(
    'src',
    `${SERVER_URL}images/dragons/${SERVER_IMAGES_SIZE_MAP[SIZE_TYPES.SMALL_2X]}/${id}.png`,
  );
  img.style.position = 'absolute';
  img.style.top = '18%'; // Or '108px';
  img.style.opacity = '1';
  img.style.transition = `opacity ${transitionDuration}ms linear`;
  root.appendChild(img);

  const canvas = document.createElement('canvas');

  canvas.setAttribute('width', width.toString(10));
  canvas.setAttribute('height', height.toString(10));
  canvas.style.opacity = '0';
  canvas.style.transition = `opacity ${transitionDuration}ms linear`;
  root.appendChild(canvas);

  const [{ data: { data: { dragon } } }] = await Promise.all([
    axios.post(SUBGRAPH_URL, {
      query: DRAGON_DETAILS_QUERY,
      variables: { id },
    }),
    initDragonRenderer(SIZE_TYPES.SMALL_2X),
  ]);

  if (!dragon) {
    throw new Error('The dragon with this id does not exist');
  }

  await renderAnimationToCanvas({
    id,
    skeleton,
    canvas,
    width,
    height,
    races: getRacesWeights(dragon.types),
    genome: parseGenome(dragon.genome),
  }, SIZE_TYPES.SMALL_2X);

  img.style.opacity = '0';

  setTimeout(() => {
    canvas.style.opacity = '1';
    removeImage();
  }, transitionDuration);
}

render();
